import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class TopBar extends React.Component {

    render() {

        const { loggedIn, user } = this.props;             

        return (
            <div className="topbar">               

                <div className="desktop-items">

                    {!loggedIn ?
                        <Link to="/login">
                            <div className="top-bar-auth-button login">
                                Login
                            </div>
                        </Link> : null
                    }
                    {!loggedIn ?
                        <Link to="/signup">
                            <div className="top-bar-auth-button register">
                                Register
                             </div>
                        </Link> : null
                    }

                 
                   

                    {loggedIn ?
                       
                            <div className="account-holder">
                                <h3>
                                   
                                    <br />
                                    <small>{user.firstName} {user.lastName}</small>
                                </h3>

                                {/* <img className="profile" src={profilePictureUrl(userInfo.profilePictureUrl)} alt="profile" /> */}
                                <img className="profile" src="/images/admin.png" alt="profile" />
                            </div>
                         : null
                   }
                </div>
                <div className="mobile-items">
                   
                    <Link to="/">
                        <img src="images/wgc-logo.png" className="mobile-logo" alt=""/>
		            </Link>

                    <div className="menu-open">
                        <img className="open" src="images/mobile-menu-open.svg" alt="Open menu"/>
                        <img className="close" src="images/mobile-menu-close.svg" alt="Close menu"/>
		            </div>
	            </div>
            </div>
        );
    }
}


function profilePictureUrl(url) {
    var newUrl = typeof url === 'undefined' ? '/images/profile-picture.png' : url;
    return newUrl;
}

function mapStateToProps(state) {
    console.log('TopBar: Mapping state to props');
    const { loggedIn, user } = state.userReducer;
    return {
        loggedIn,
        user
    };
}

const topBar = connect(mapStateToProps)(TopBar);
export { topBar as TopBar }; 